import React, { useState } from "react";
import HeaderTitle from "./components/HeaderTitle";
import InvoiceTab from "./components/InvoiceTab";
import { Table } from "react-bootstrap";

function InvoiceList() {
  return (
    <div>
      {/* header  */}
      <HeaderTitle />
      {/* header  */}
      <div style={{ padding: "0 9px" }}>
        {/* invoice */}
        <InvoiceTab />
        {/* invoice */}

        {/* show list invoice */}
        <ListAllInvoice />
        {/* show list invoice */}
      </div>
    </div>
  );
}

export default InvoiceList;

const ListAllInvoice = () => {
  return (
    <React.Fragment>

      <p style={{fontWeight:700, fontSize:22, marginTop:10}}>ຈຳນວນສະແດງທັງໝົດ (100)</p>

      <Table responsive>
        <thead>
          <tr style={{ whiteSpace: "nowrap"}}>
            <th style={{ borderBottom: "1px solid #eeeeee" }}>ລດ</th>
            <th style={{ borderBottom: "1px solid #eeeeee" }}>ເລກບິນ</th>
            <th style={{ borderBottom: "1px solid #eeeeee" }}>ວັນທີແຈ້ງຖອນ</th>
            <th style={{ borderBottom: "1px solid #eeeeee" }}>ຈຳນວນເງິນແຈ້ງຖອນ</th>
            <th style={{ borderBottom: "1px solid #eeeeee" }}>ສະຖານະການຖອນ</th>
            <th style={{ borderBottom: "1px solid #eeeeee" }}>ວັນທີຢືນຢັນ</th>
            <th style={{ borderBottom: "1px solid #eeeeee" }}>ຄ່າທຳນຽມ</th>
            <th style={{ borderBottom: "1px solid #eeeeee" }}></th>
          </tr>
        </thead>
        <tbody></tbody>
      </Table>
    </React.Fragment>
  );
};
